// gkc_hash_code : 01EV64EDXCZTX8ZCEMHJHDQ126
import styled from 'styled-components';

export const Layout = styled.main`
  min-height: 100vh;
  color: ${({ theme }) => theme.color.black};
  background-color: ${({ theme }) => theme.color.white};

  @media only screen and (min-width: 426px) {
    background-color: ${({ theme }) => theme.color.grey4};
  }
`;
